<template>
  <div class="forget-password-container">
    <Language/>
    <div class="title">{{ $t('onboarding.common.forgetPasswordTitle') }}</div>
    <div class="input-form-div" :class="isPc ? 'pc' : 'mobile'">
      <SimpleForm
        :model="accountInfo"
        :formLines="formLines"
        :formStyle="formStyle"
        :labelWidth="labelWidth"
        labelPosition="left"
        :hideRequiredAsterisk="true"
        @submit="handleReset"
      >
      </SimpleForm>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SimpleForm from '@/components/formEditor/simpleForm.vue'
import { validateEmail } from '@/utils/validator'
import Language from './language.vue'
import mixin from './mixin'

export default {
  mixins: [mixin],
  components: {
    SimpleForm, Language
  },
  data () {
    return {
      accountInfo: {
        email: ''
      },
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }]
    }
  },
  computed: {
    formLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      return {
        email: {
          label: this.$t('hm.label.userName'),
          rules: [
            { required: true, message: requiredMessage, trigger: 'blur' },
            { validator: validateEmail, trigger: ['blur', 'change'] }
          ]
        },
        submitBtn: {
          type: 'submitBtn',
          class: 'submit-btn-container',
          btnText: this.$t('hm.btn.submit')
        }
      }
    },
    formStyle () {
      return { width: '100%', 'font-size': '16px' }
    },
    labelWidth () {
      return '31%'
    }
  },
  created () {
  },
  methods: {
    ...mapActions('hm', ['forgetHmPassword']),
    async handleReset (isValid) {
      if (!isValid) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.forgetHmPassword({
          email_address: this.accountInfo.email
        })
        if (resp) {
          this.$alert(
            this.$t('questionnaire.message.resetEmailSuccess'),
            this.$t('questionnaire.title.alert'),
            {
              customClass: 'alert-message-box',
              callback: action => {
                this.$router.push({ name: 'loginPage' })
              }
            }
          )
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.forget-password-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .title {
    font-weight: bolder;
    text-align: center;
    font-size: 24px;
    margin: 2em 0 4em 0;
  }

  .input-form-div {
    min-width: 350px;

    &.pc {
      width: 450px;
    }

    ::v-deep .submit-btn-container {
      .el-form-item__content {
        position: relative;
        margin-left: 30%;
        width: 70%;
      }

      .submit-btn {
        position: absolute;
        right: 5px;
        background-color: #0096cc;
        border: 0;
        color: #FFFFFF;
        font-size: 16px;
        margin-top: 70px;
        width: 57%;

        &:hover {
          color: #FFFFFF;
        }
      }
    }

    ::v-deep .el-form-item__label {
      font-size: 16px;
      font-weight: 400;
    }

    &.mobile {
      ::v-deep .el-form-item__label {
        font-size: 16px;
      }
    }
  }
}
</style>
